import { Component } from '@angular/core';

@Component({
  selector: 'app-water-diposal',
  standalone: false,
  templateUrl: './water-diposal.component.html',
  styleUrl: './water-diposal.component.scss'
})
export class WaterDiposalComponent {
//  waterAppUrl: string = 'https://surface-prod.crm.dynamics.com/main.aspx?appid=a84f05c8-7109-f011-bae4-6045bd084d01&pagetype=entitylist&etn=new_waterdisposalstandards&viewid=ad370ca1-5d84-4300-bf8b-0cfc65dcd836&viewType=1039&lid=1744046147687';

}
